<div class="portfolio-details-card portfolio-details-card-margin tile-card-structure">
    <div class="portfolio-card-structure">
        <div class="padu-dropdown-data mt-1" >
            <span class="card-heading  table-Header-Nav-font tile-heading year-label-margin">Forecast {{forecastDetailsMap.get('currentYear_prev_no')}} ({{forecastDetailsMap.get('currentForecastCycle')}})</span>

        </div>
        <div class="padu-card-width" >
            <div class="padu-container">
                <span class="padu-status-heading table-data-font"> {{forecastDetailsMap.get('previousYear_prev_no')}} FY</span>
                <div class="padu-status-detail padu-status-detail-height preffered"
                    [ngClass]="{'padu-status-detail-shadow preffered-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalPrevYearFYCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
        <div class="padu-card-width"  >
            <div class="padu-container" >
                <span class="padu-status-heading table-data-font">{{forecastDetailsMap.get('currentYear_prev_no')}} Projections</span>
                <div class="padu-status-detail padu-status-detail-height acceptable"
                    [ngClass]="{'padu-status-detail-shadow acceptable-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalInfraProjectedCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
        <div class="padu-card-width" >
            <div class="padu-container"  >
                <span class="padu-status-heading table-data-font">{{forecastDetailsMap.get('currentYear_prev_no')}} FC ({{forecastDetailsMap.get('previousForecastCycle')}})</span>
                <div class="padu-status-detail padu-status-detail-height discouraged"
                    [ngClass]="{'padu-status-detail-shadow discouraged-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalCurrYearFCPrevCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
        <div class="padu-card-width" >
            <div class="padu-container"  >
                <span class="padu-status-heading table-data-font">{{forecastDetailsMap.get('currentYear_prev_no')}} FC ({{forecastDetailsMap.get('currentForecastCycle')}})</span>
                <div class="padu-status-detail padu-status-detail-height unacceptable"
                    [ngClass]="{'padu-status-detail-shadow unacceptable-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalCurrYearFCCurrCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
        <div class="padu-card-width" >
            <div class="padu-container"  >
                <span class="padu-status-heading table-data-font">{{forecastDetailsMap.get('nextYear_prev_no')}} FC ({{forecastDetailsMap.get('previousForecastCycle')}})</span>
                <div class="padu-status-detail padu-status-detail-height to-be-retired"
                    [ngClass]="{'padu-status-detail-shadow to-be-retired-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalFutureYearFCPrevCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
        <div class="padu-card-width" >
            <div class="padu-container"  >
                <span class="padu-status-heading table-data-font">{{forecastDetailsMap.get('nextYear_prev_no')}} FC ({{forecastDetailsMap.get('currentForecastCycle')}})</span>
                <div class="padu-status-detail padu-status-detail-height retired" [ngClass]="{'padu-status-detail-shadow retired-border': true}">
                    <span class="padu-app-count"
                        *ngIf="dataLoaded">${{forecastDetailsMap.get('totalFutureYearFCCurrCharges')| digitFormatter:'1'}}</span>
                </div>
            </div>
        </div>
    </div>

</div>